var requireLogin = require('mobile/widgets/requireLogin')
  , $ = require('jquery')
  , ajaxIsUserScheGame = require('apis/ajaxIsUserScheGame')
  , GAME_TYPE_SHOUYOU = 'GAME_TYPE_SHOUYOU'
  , GAME_TYPE_NEWGAME = 'GAME_TYPE_NEWGAME'
  , openAlert = require('mobile/ui/openAlert')
  , EngageByApp = require('mobile/widgets/EngageByApp')
  , handleEngageGame = require('mobile/widgets/handleEngageGame')
  , ERROR_MSG = '网络发生了错误'
  , detector = require('widgets/detector')

function engageGame(gameCode, gameName, channelType, triggerBtn) {
  if (detector.isAndroid() && ued.newgameCodes && (ued.newgameCodes.Android || ued.newgameCodes.PC)) {
    var engageDiaog = new EngageByApp({
        gameCode: gameCode
      , gameName: gameName
      , channelType: channelType
      , triggerBtn: triggerBtn
    })

    engageDiaog.render().open()
  } else {
    handleEngageGame(gameCode, channelType, triggerBtn)
  }

}

module.exports = requireLogin(function(e) {
  var ued = window.ued || {}
    , element = $(e.currentTarget)
    , gameCode = element.data('game-code') || ued.gameCode
    , gameName = element.data('game-name') || ''
    , channelType = element.data('channel-type')

  ajaxIsUserScheGame(gameCode, Passport.data('uid'))
    .done(function (isFollowed) {
      var btnText = '已预定';
      var alertTitle = '预订成功';
      // 如果是关注游戏按钮
      if (element.hasClass('btn-follow-current-game') || element.text().indexOf('关注') !== -1) {
        btnText = '已关注';
        alertTitle = '关注成功';
      }
      if (isFollowed) {
        element.addClass('disable')
          .removeClass('btn-engage-current-game')
          .text(btnText)
        return openAlert({ content: alertTitle })
      } else {
        return engageGame(gameCode, gameName, channelType, element)
      }
    })
    .fail(function() {
      return engageGame(gameCode, gameName, channelType, element)
    })

})
